import * as React from 'react';

import { Link, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';

export interface InfoPanelProps {
    workshop?: string,
    location: string,
    startDate: string,
    endDate: string,
    fee?: number,
    logInfo?: string,
    guid?: string,
    supportMail: string
}

function isFalsyOrEmpty(str?: string) {
    return !(str && str.trim());
}

export const WorkshopInfoPanel = ({location, startDate, endDate, fee, logInfo, guid, supportMail}: InfoPanelProps) => {
    
    return <Grid container size={12} rowSpacing={0} borderTop={.5} sx={{borderColor: 'lightGrey'}} borderBottom={.5}>
        <Grid size={4}>
            <Typography variant="bold">{"Location"}:</Typography>
        </Grid>
        <Grid size={8} >
            <Typography variant="bold">{location}</Typography>
            <Typography>{startDate} - {endDate}</Typography>
            {guid && <Typography>{guid}</Typography>}
        </Grid>
        <Grid size={4}>
            <Typography variant="bold">{"Logistic Information:"}</Typography>
        </Grid>
        <Grid size={8}>
            {!isFalsyOrEmpty(logInfo) ? <Link href={logInfo}>{logInfo}</Link> : "No additional information available"}
        </Grid>
        <Grid size={4}>
            <Typography variant="bold">{"For support requests:"}</Typography>
        </Grid>
        <Grid size={8}>
            <Typography><Link href={`mailto:${supportMail}`}>{supportMail}</Link></Typography>
        </Grid>
    </Grid>
}

